/**
 * Pure-SPA entry. Mounts the TanStack Router into #root. No SSR.
 *
 * Originally Lovable scaffolded this as TanStack Start (Cloudflare Workers
 * SSR). We stripped Start + Cloudflare 2026-05-11 so the app deploys cleanly
 * on Vercel alongside the rest of StockClerk. The product is a single-page
 * form that POSTs to api.stockclerk.app; SSR is not needed.
 */

import "./styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient },
  scrollRestoration: true,
  defaultPreloadStaleTime: 0,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Mount point #root missing from index.html");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
